// return new message list after deduplicate
export const getNewMessageList = (oldMessages: any, newMessages: any) => {
  const oldIds = oldMessages.map((message: any) => {
    return message.id;
  });

  const newMessageList = newMessages
    .map((message: any) => {
      if (oldIds.indexOf(message.id) === -1) {
        return message;
      }
      return null;
    })
    .filter((message: any) => {
      if (message !== null) {
        return true;
      } else {
        return false;
      }
    });

  return newMessageList;
};
